angular.module('dpw.directives')
    .directive('dpwOpenCopyPopup', [function () {
        return {
            restrict: 'A',
            scope: {
                text: '=',
                isTransclude: '@',
                extraClass: '@'
            },
            transclude: true,
            controller: ['$scope', function ($scope) {
                var self = this;
                self.isTransclude = ($scope.isTransclude === 'true');
                var btnCopy = new ClipboardJS('.dpw-open-copy-btn');
                self.openCopy = function () {
                    self.copyValue = $scope.text;
                };
            }],
            controllerAs: 'ctrl',
            templateUrl: 'dpw-open-copy-popup.html'
        };
    }]);